import React, { FC, useContext } from 'react';
import { withFeatures } from '../../../features/withFeatures';
import { NavLawyerProfile } from './NavLawyerProfile';
import { UserContext } from '../../../user/UserContext';

export const RawNavUserLawyer: FC = () => {
  const { currentUser } = useContext(UserContext);

  if (!currentUser.lawyerId) return null;

  return (
    <NavLawyerProfile
      pictureUrl={currentUser.pictureUrl}
      href={`/p/avocat/${currentUser.lawyerId}?source=nav_dropdown`}
      name={currentUser.isExpired ? currentUser.name : ''}
    />
  );
};

export const NavUserLawyer = withFeatures('nav/user')(RawNavUserLawyer);
